/**
 * Main JS
 *
 * @copyright 2021 NB Communication Ltd
 *
 */

var uk = UIkit.util;


//
// Components
//
window.theme = window.theme || {};

// Currency Selector
theme.CurrencySelector = (function () {
	var selectors = {
		form: "form",
		select: 'select[name="currency"]',
		options: 'input.uk-radio'
	};


	function CurrencySelector(container) {

		this.$containers = uk.$$(container);
		var $container, form, options;

		for(var i = 0; i < this.$containers.length; i++){
			$container = this.$containers[i];
			form = uk.$(selectors.form, $container);
			options = uk.$$(selectors.options, $container);
			// Bind Events
			uk.on(options, "change", this.onChange.bind(this));
		}
	}


	CurrencySelector.prototype = Object.assign({}, CurrencySelector.prototype, {

		onChange: function (evt) {
			var select;
			var target = evt.target, selectedValue, options, form;
			selectedValue = target.value;
			form = uk.$("form", target.parentNode.parentNode.parentNode);
			select = uk.$('select[name="currency"]', form);

			options = select.options;

			for (var opt, j = 0; opt = options[j]; j++) {
				//If the option of value is equal to the option we want to select.
				if (opt.value == selectedValue) {
					//Select the option and break out of the for loop.
					select.selectedIndex = j;
					break;
				}
			}
			form.submit();
		}
	});
	return CurrencySelector;
})();


const main = {

	init: () => {

		// Content
		const blocks = uk.$$('.content');
		if (blocks.length) {

			blocks.forEach((block) => {

				// Apply UIkit table component
				uk.$$('table', block).forEach((el) => {
					uk.addClass(el, 'uk-table');
					uk.wrapAll(el, '<div class="uk-overflow-auto">');
				});

				// Inline Images UIkit Lightbox/Scrollspy
				(uk.$$('a[href]', block).filter((a) => {
					return uk.attr(a, 'href').match(/\.(jpg|jpeg|png|gif|webp)/i);
				})).forEach((a) => {

					const figure = a.parentElement;
					if (figure.nodeName !== 'FIGURE') {
						uk.wrapAll(a, '<figure>');
						figure = a.parentElement;
					}

					const img = uk.$('img', a);
					if (uk.hasAttr(img, 'class')) {
						uk.addClass(figure, uk.attr(img, 'class'));
						uk.removeAttr(img, 'class');
					}

					const caption = uk.$('figcaption', figure);

					// uk-lightbox
					uk.attr(figure, 'data-uk-lightbox', 'animation: fade');
					if (caption) uk.attr(a, 'data-caption', nb.wrap(uk.html(caption), 'div'));
				});
			});
		}

		main.mmenu();
		main.currencySelector();

	},

	mmenu: () => {

		const el = uk.$('#mmenu');
		if (!el) return;

		const menu = new Mmenu(el,
			{
				extensions: [
					'border-full',
					'fullscreen',
					'position-front',
				],
			},
			{
				classNames: {
					selected: 'uk-active'
				},
				transitionDuration: 256
			}
		);

		uk.removeClass(el, 'uk-hidden');

		const toggle = uk.$('.uk-navbar-toggle');
		if (toggle) {

			const toggleIcons = uk.$$('span', toggle);
			const toggler = (open) => {
				uk[`${open ? 'add' : 'remove'}Class`](toggle, 'uk-open');
			};

			menu.API.bind('close:start', () => toggler(false));
			uk.on(toggle, 'click', () => toggler(!uk.hasClass(this, 'uk-open')));

			// Set distance of the top border of the screen

            const header_h = uk.height(uk.$('#shopify-section-header'));
            console.log(header_h);
            uk.attr(uk.$("#mmenu"), "style", "top: " + header_h + "px !important");
		}
	},

	currencySelector:() => {
		new theme.CurrencySelector(".currency-selector");
	}
};
uk.ready(() => main.init());